import th from "element-plus/es/locale/lang/th";

const thLocale = {
  ...th,
  el: {
    colorpicker: {
      confirm: "ตกลง",
      clear: "ล้างข้อมูล",
    },
    datepicker: {
      now: "ตอนนี้",
      today: "วันนี้",
      cancel: "ยกเลิก",
      clear: "ล้างข้อมูล",
      confirm: "ตกลง",
      selectDate: "เลือกวันที่",
      selectTime: "เลือกเวลา",
      startDate: "วันที่เริ่มต้น",
      startTime: "เวลาเริ่มต้น",
      endDate: "วันที่สิ้นสุด",
      endTime: "เวลาสิ้นสุด",
      prevYear: "ปีก่อนหน้า",
      nextYear: "ปีถัดไป",
      prevMonth: "เดือนก่อนหน้า",
      nextMonth: "เดือนถัดไป",
      year: "",
      month1: "มกราคม",
      month2: "กุมภาพันธ์",
      month3: "มีนาคม",
      month4: "เมษายน",
      month5: "พฤษภาคม",
      month6: "มิถุนายน",
      month7: "กรกฎาคม",
      month8: "สิงหาคม",
      month9: "กันยายน",
      month10: "ตุลาคม",
      month11: "พฤศจิกายน",
      month12: "ธันวาคม",
      // update the following lines as per your locale
      weeks: {
        sun: "อา",
        mon: "จ",
        tue: "อ",
        wed: "พ",
        thu: "พฤ",
        fri: "ศ",
        sat: "ส",
      },
      months: {
        jan: "ม.ค.",
        feb: "ก.พ.",
        mar: "มี.ค.",
        apr: "เม.ย.",
        may: "พ.ค.",
        jun: "มิ.ย.",
        jul: "ก.ค.",
        aug: "ส.ค.",
        sep: "ก.ย.",
        oct: "ต.ค.",
        nov: "พ.ย.",
        dec: "ธ.ค.",
      },
    },
  },
  test: "test",
  thai: "ไทย",
  english: "en",
  email: "อีเมล",
  password: "รหัสผ่าน",
  forgot: "ลืมรหัสผ่าน?",
  or: " หรือ",
  login: "เข้าสู่ระบบ",
  loginPlus: "เข้าสู่ระบบด้วย S+",
  loginPlusV5: "เข้าสู่ระบบด้วย S+ V5",
  loading: "กรุณารอสักครู่",
  waiting: "กรุณารอสักครู่",
  sendingData: "เรากำลังส่งข้อมูลของคุณ",
  hello: "สวัสดี,",
  riskScore: "ความเสี่ยงของคุณ",
  getRiskTitle: "ประเมินความเสี่ยงของคุณ",
  getRiskDesc1: "เราจะวิเคราะห์ความเสี่ยงของคุณจาก",
  getRiskDesc2: "แบบสอบถามด้านสุขภาพ",
  noRisk: "คุณไม่มีความเสี่ยง",
  questionNo: "คำถามที่",
  outOf: "จาก",
  nothaverisksuggest: `
&ensp;&ensp; การตรวจสุขภาพขึ้นอยู่กับอายุ สุขภาพโดยรวม โรคประจำตัว ประวัติครอบครัว และรูปแบบการใช้ชีวิตของแต่ละบุคคล โดยทั่วไปแล้วโปรแกรมตรวจสุขภาพเบื้องต้นจะแบ่ง ตามเพศและอายุ โดยแพทย์แนะนำให้ตรวจเป็นประจำทุก 1 ปี  สำหรับผู้ที่มีปัจจัยเสี่ยงต้องเฝ้าระวังเป็นพิเศษอาจจำเป็นต้องมีการตรวจเพิ่มเติม <br/>
- อายุ 20 ปีขึ้นไป ทุกเพศ ตรวจสุขภาพประจำปีอย่างน้อยปีละครั้ง <br/><br/>`,
  nothaverisksuggest2: `
  &ensp;&ensp; การตรวจสุขภาพขึ้นอยู่กับอายุ สุขภาพโดยรวม โรคประจำตัว ประวัติครอบครัว และรูปแบบการใช้ชีวิตของแต่ละบุคคล โดยทั่วไปแล้วโปรแกรมตรวจสุขภาพเบื้องต้นจะแบ่ง ตามเพศและอายุ โดยแพทย์แนะนำให้ตรวจเป็นประจำทุก 1 ปี สำหรับผู้ที่มีปัจจัยเสี่ยงต้องเฝ้าระวังเป็นพิเศษอาจจำเป็นต้องมีการตรวจเพิ่มเติม <br/>
  - อายุ 20 ปีขึ้นไป ทุกเพศ ตรวจสุขภาพประจำปีอย่างน้อยปีละครั้ง <br/><br/>
  *** หมายเหตุ :<br/>&ensp;&ensp; - อายุ 20 ปีขึ้นไป เพศหญิง ตรวจมะเร็งปากมดลูก พบมากเป็นอันดับหนึ่งของผู้หญิงไทย การตรวจคัดกรองมะเร็งปากมดลูก (Cervical Cancer) อย่างสม่ำเสมอทำให้มีโอกาสตรวจพบได้ตั้งแต่ระยะเริ่มแรกและรักษาได้ สามารถเริ่มตรวจได้เมื่อเริ่มมีเพศสัมพันธ์  <br/>
  &ensp;&ensp;- หากมีอาการโรคมะเร็ง , โรคเบาหวาน , โรคความดันโลหิตสูง และโรคหัวใจ จะไม่มีสรุปการประเมินความเสี่ยงโรคซ้ำ แนะนำให้ลูกค้าเลือกแพ็กเกจตรวจสุขภาพทั่วไป 
    `,
  noRiskNew: `หมายเหตุ : อายุ 20 ปีขึ้นไป ทุกเพศ แนะนำให้ตรวจสุขภาพประจำปี อย่าง
    น้อยปีละครั้ง ระบบจะไม่ประเมินความเสี่ยงซ้ำ โรคที่ตรวจพบหรือเป็นอยู่ก่อน
    หน้านี้แล้ว แนะนำให้เลือกแพ็กเกจตรวจสุขภาพทั่วไป`,
  testAgain: "ทดสอบอีกครั้ง",
  getRiskButton: "ทำแบบสอบถาม",
  healthPackage: "แพ็กเกจตรวจสุขภาพ",
  seeAll: "ดูทั้งหมด",
  bundlePackage: "แพ็กเกจตรวจสุขภาพสำหรับคุณ",
  yourPersonalizePackage: "แพ็กเกจตรวจสุขภาพสำหรับคุณ",
  suggest: "คำแนะนำสำหรับคุณ",
  search: "ค้นหา",
  notFound: "ไม่พบแพ็กเกจที่คุณค้นหา",
  nothave: "ตอนนี้ยังไม่มีแพ็กเกจที่แนะนำ",
  nothavePack: "ไม่มีแพ็กเกจที่ท่านเลือก",
  searching1: "ระบบกำลังค้นหาแพ็กเกจ",
  searching2: "ที่เหมาะกับคุณ",
  packageForYou: "แพ็กเกจสำหรับคุณ",
  choosehospital: "เลือกโรงพยาบาล",
  location: "สถานที่",
  dateAppointment: "วันที่",
  checkTheDetail: "กรุณาตรวจสอบรายละเอียดด้านล่าง",
  appdate: "วันที่",
  sukhumvit: "สมิติเวช สุขุมวิท",
  srinakarin: "สมิติเวช ศรีนครินทร์",
  sriracha: "สมิติเวช ศรีราชา",
  thonburi: "สมิติเวช ธนบุรี",
  chonburi: "สมิติเวช ชลบุรี",
  chinatown: "สมิติเวช ไชน่าทาวน์",
  sukhumvitHospital: "โรงพยาบาล สมิติเวชสุขุมวิท",
  srinakarinHospital: "โรงพยาบาล สมิติเวชศรีนครินทร์",
  srirachaHospital: "โรงพยาบาล สมิติเวชศรีราชา",
  thonburiHospital: "โรงพยาบาล สมิติเวชธนบุรี",
  chonburiHospital: "โรงพยาบาล สมิติเวชชลบุรี",
  chinatownHospital: "โรงพยาบาล สมิติเวชไชน่าทาวน์",
  SVH: "สุขุมวิท",
  SNH: "ศรีนครินทร์",
  SSH: "ศรีราชา",
  STH: "ธนบุรี",
  SCH: "ชลบุรี",
  SCT: "ไชน่าทาวน์",
  SVGTextContentElement: "สมิติเวช ไชน่าทาวน์",
  pleasSelect: "กรุณาเลือกแพ็กเกจ ",
  pleasSelect2: " ก่อนเลือกแพ็กเกจนี้",
  pleaseUnselect: "มีรายการตรวจซ้ำกับแพ็กเกจอื่น",
  someDetailDup: "* มีรายการตรวจซ้ำกัน",
  pleaseUnselect2: "กรุณาเลือกแพ็กเกจนี้เพียงแพ็กเกจเดียว",
  pleasOptSelect: "ถูกลงเมื่อซื้อกับ",
  prerequisiteCategory: "แพ็กเกจที่ต้องซื้อคู่",
  prerequisiteCategoryฺBeforeDiscount: "แพ็กเกจซื้อคู่ถูกลง",
  recommend: "แพ็กเกจที่แนะนำ",
  selectAll: "เลือกทั้งหมด",
  total: "ทั้งหมด",
  baht: "บาท",
  skip: "ข้าม",
  start: "เริ่มเลย",
  syncData: "เชื่อมข้อมูลสมิติเวช",
  yesSync: "เชื่อม",
  noSync: "ไม่เชื่อม",
  next: "ถัดไป",
  questionatitle:
    "ทำแบบประเมินสุขภาพนี้ เพื่อช่วยวิเคราะห์ค่าความเสี่ยงของคุณ และปรับแต่งแผนสุขภาพของคุณ",
  sex: "เพศของคุณ",
  male: "ชาย",
  female: "หญิง",
  dateofbirth: "วันเกิดของคุณ",
  date: "วันที่",
  month: "เดือน",
  year: "ปี",
  january: "มกราคม",
  february: "กุมภาพันธ์",
  march: "มีนาคม",
  april: "เมษายน",
  may: "พฤษภาคม",
  june: "มิถุนายน",
  july: "กรกฎาคม",
  august: "สิงหาคม",
  september: "กันยายน",
  october: "ตุลาคม",
  november: "พฤศจิกายน",
  december: "ธันวาคม",
  career: "อาชีพ",
  ผู้บริหาร: "ผู้บริหาร",
  ธุรกิจส่วนตัว: "ธุรกิจส่วนตัว",
  พนักงานรัฐ: "พนักงานรัฐ",
  พนักงานบริษัท: "พนักงานบริษัท",
  นักกีฬา: "นักกีฬา",
  ว่างงาน: "ว่างงาน",
  "นักเรียน/นักศึกษา": "นักเรียน/นักศึกษา",
  อื่นๆ: "อื่นๆ",
  specify: "โปรดระบุ",
  pleaseFill: "กรุณากรอกข้อมูลให้ครบถ้วน",
  bodyDetail: "ข้อมูลสุขภาพของคุณ",
  height: "ส่วนสูง",
  weight: "น้ำหนัก",
  bmi: "BMI",
  waistline: "รอบเอว",
  centimeter: "ซม.",
  kilogram: "กก.",
  kmpermg: "กก./ม.²",
  inch: "นิ้ว",
  yourRisk: "คุณมีความเสี่ยงระดับ ",
  compareWithNormal: " เมื่อเทียบกับคนทั่วไป",
  moreSuggestionButton: "คำแนะนำเพิ่มเติม",
  //// healthdetail
  healthdetail: "ข้อมูลสุขภาพเพิ่มเติม",
  optional: "(ถ้ามี)",
  bloodpressure: "ความดันโลหิต",
  sbp: "ความดันตัวบน",
  dbp: "ความดันตัวล่าง",
  cholesterol: "คอเลสเตอรอล",
  cholesterolLDL: "ระดับไขมัน LDL",
  bloodsugar: "น้ำตาลในเลือด (FBS)",
  HbA1c: "น้ำตาลสะสมในเลือด (HbA1C)",
  mmhg: "mmHg",
  mgdl: "mg/dL",
  pleaseFillDiseaseCompletely: "โปรดกรอกข้อมูลให้ครบถ้วน",
  //// behavior
  behavior: "ท่านมีพฤติกรรมดังต่อไปนี้หรือไม่",
  snoring: "นอนกรนและเหนื่อยเพลียหลังตื่นนอน",
  alcohol: "ดื่มแอลกอฮอล์เกินกว่าวันละ 2 แก้วเป็นประจำ",
  healthcheck: "ตรวจสุขภาพภายใน 1 ปี",
  healthcheck2: "ภายใน 1 ปี",
  nothealthcheck: "ไม่เคยตรวจสุขภาพ",
  smoking: "สูบบุหรี่",
  airPollution: "ทำงานในสถานที่ที่มีฝุ่นควัน หรือมลภาวะทางอากาศ",
  morethanone: "ตอบได้มากกว่า 1 ข้อ หากไม่มีพฤติกรรมเหล่านี้กดถัดไป",
  //// disease
  you: `"ท่าน"`,
  disease: " มีประวัติเป็นโรค ดังต่อไปนี้หรือไม่",
  cancer: "โรคมะเร็ง",
  diabete: "โรคเบาหวาน",
  hypertension: "โรคความดันโลหิตสูง",
  cvd: "โรคหัวใจ",
  kidney: "โรคไต",
  stroke: "โรคหลอดเลือดสมอง",
  metabolic: "ภาวะอ้วนลงพุง",
  none: "ไม่มีโรคประจำตัว",
  other: "อื่นๆ",
  pleaseFillDisease: "โปรดระบุ",
  morethanonedisease: "( ตอบได้มากกว่า 1 ข้อ )",
  morethanonedisease2:
    "( ตอบได้มากกว่า 1 ข้อ หากไม่มีอาการเหล่านี้เลือกไม่มีโรคประจำตัว )",
  suggestedisease:
    "*หากมีอาการโรคดังรายการนี้ จะไม่มีการประเมินความเสี่ยงโรคดังกล่าว ขึ้นมา แนะนำให้ลูกค้าเลือกแพ็คเกจตรวจสุขภาพทั่วไป",
  suggestedisease2:
    "* หากมีอาการโรคมะเร็ง , โรคเบาหวาน , โรคความดันโลหิตสูง และโรคหัวใจ จะไม่มีสรุปการประเมินความเสี่ยงโรคซ้ำ แนะนำให้ลูกค้าเลือกแพ็กเกจตรวจสุขภาพทั่วไป",
  //// family disease
  family: `"ครอบครัว"`,
  famdisease: "มีประวัติเป็นโรค ดังต่อไปนี้หรือไม่",
  //// main
  mainReason:
    "มาเริ่มด้วยการคิดว่าเหตุใดกิจกรรมจึงสำคัญสำหรับคุณ เหตุผลหลักที่คุณเลือกคืออะไร",
  loseWeight: "ลดน้ำหนัก",
  moreActive: "กระฉับกระเฉงขึ้น",
  activeTrack: "กระตือรือร้นและต้องการรักษาระดับ",
  overallHealth: "แอคทีฟเป็นสิ่งสำคัญสำหรับสุขภาพโดยรวม",
  //// exercise
  exercise: "คุณออกกำลังกายกี่ครั้งต่อสัปดาห์",
  lessThan3day: "น้อยกว่า 3 วัน",
  d3To5: "3-5 วัน",
  d6To7: "6-7 วัน",
  dontdo: "ไม่ออกกำลังกาย",
  select: "กรุณาเลือกคำตอบ",
  //// exercise time
  exercisetime: "คุณออกกำลังกายครั้งละกี่นาที",
  less15: "น้อยกว่า 15 นาที",
  f15t30: "15-30 นาที",
  f30t1: "30 นาที - 1 ชม.",
  more1: "มากกว่า 1 ชม.",
  sportsTrain: "คุณฝึกซ้อม หรือแข่งกีฬาเป็นประจำหรือไม่",
  yes: "ใช่",
  no: "ไม่",
  ////Assessment Report
  cvdlevel1: "น้อย",
  cvdlevel2: "ปานกลาง",
  cvdlevel3: "สูง",
  cvdlevel4: "สูงมาก",
  cvdlevel5: "สูงอันตราย",
  dmlevel1: "น้อย",
  dmlevel2: "ปานกลาง",
  dmlevel3: "สูง",
  dmlevel4: "สูงมาก",
  dmlevel5: "สูงมากๆ",
  ccalevel1: "น้อย",
  ccalevel2: "ปานกลาง",
  ccalevel3: "สูง",
  gotohome: "กลับสู่หน้าหลัก",
  yourisklevelof: "ความเสี่ยง",
  suggest50y:
    "* คำแนะนำเพิ่มเติมสำหรับคุณ ในผู้ที่มีอายุ 45 ปีขึ้นไป ควรตรวจคัดกรองโรคมะเร็งลำไส้ใหญ่โดยการส่องกล้องเพื่อป้องกันและหาความผิดปกติก่อนเกิดระยะลุกลาม",
  ////Packageforyou
  notFillDate: "กรุณาเลือกวันที่นัดหมาย",
  notFillPhoneNumber: "กรุณากรอกข้อมูล",
  notFillDate2: "กรุณาเลือกวันที่นัดหมาย (สำรอง)",
  notSelectHospital: "กรุณาเลือกสาขาโรงพยาบาล",
  pleaseSelectHos: "กรุณาเลือกโรงพยาบาล",
  notequalDate: "วันที่นัดหมาย และวันที่นัดหมายสำรองต้องไม่ใช่วันเดียวกัน",
  thank:
    "การจองแพ็กเกจของท่านสำเร็จแล้ว<br>หากมีการเปลี่ยนแปลงเจ้าหน้าที่จะติดต่อกลับ",
  withYourPhoneNumber:
    "<p>ผ่านหมายเลขโทรศัพท์ที่คุณให้ไว้<br>ภายใน 48 ชั่วโมง</p>",
  addtocart: "ใส่ตะกร้า",
  pay: "ชำระเงิน",
  pickDate: "เลือกวันนัดหมาย",
  makeAppointment: "ทำการนัดหมาย",
  wating: "กรุณารอสักครู่...",
  seedetail: "ดูรายละเอียด",
  hideDetail: "ซ่อนรายละเอียด",
  alreadyBuy: "* ท่านเคยซื้อแพ็กเกจนี้แล้วในระยะเวลา 1 ปี",
  //qrcode
  save: "บันทึก",
  share: "แชร์",
  scan: "สแกน QR Code",
  packageDetail: "รายละเอียดของแพ็กเกจ",
  tutorial: "วิธีการใช้งาน",
  //Checkout
  checkout: "จองแพ็กเกจ",
  confirmCheckout: "ยืนยัน",
  payment: "การชำระเงิน",
  coupon: "Coupon",
  applyCoupon: "Apply Coupon",
  coin: "Coin",
  coins: "Coins",
  useCoins: "Use coins",
  cointoBaht: "10 Coins = 1 Baht",
  discount: "discount",
  haveCoins: "you have",
  paymentMethods: "Payment Methods",
  creditDebit: "Credit/Debit",
  addNewCard: "Add new card",
  mobileBanking: "Mobile Banking",
  payWith: "Pay with K PLUS",
  scb: "Pay with K PLUS",
  // cart
  cart: "รถเข็น",
  myOrder: "คำสั่งซื้อของฉัน",
  toPay: "to be paid",
  complete: "to be paid",
  orderNumber: "เลขที่ใบสั่งซื้อ",
  RiskAssessment: "ผลความเสี่ยงของคุณ",
  // confirm-popup
  confirm: "ยืนยัน",
  edit: "แก้ไข",
  //  noted for thai people
  forThai:
    "* สงวนสิทธิ์ราคาพิเศษสำหรับชาวไทยและชาวต่างชาติที่อาศัยอยู่ในประเทศไทยเท่านั้น และต้องจองล่วงหน้าอย่างน้อย 3 วันก่อนเข้ารับบริการ",
  // flash sale
  flashSale: "Promotion Flash Sale 12.12",
  flashSaleDesc:
    "รับส่วนลด 5 % สำหรับการจองแพ็กเกจตรวจสุขภาพผ่าน Health Checkup",
  flashSaleDesc2: "พิเศษเฉพาะวันที่ 12 ธันวาคม 2566 เวลา 00:01 น.",
  flashSaleDesc3: "ถึงวันที่ 13 ธันวาคม 2566 เวลา 23:59 น. เท่านั้น!",
  flashSaleRemark:
    "หมายเหตุ: เมื่อทําการจองแพ็กเกจเสร็จสมบูรณ์ ท่านจะได้รับคูปองส่วนลด 5% ซึ่งจะถูกแนบมากับอีเมลยืนยันการจองแพ็กเกจ โปรดนําคูปองนี้ไปแสดงที่เคาน์เตอร์ชําระเงิน ณ โรงพยาบาลที่ท่านใช้บริการเพื่อรับส่วนลด 5%",
  flashSaleRemark2:
    "สอบถามเพิ่มเติม กรุณาติดต่อ Line Official Account: @WellbySamitivej",
  gotoHealthPackages: "จองเลย",
  // new home
  doYouKnowYourRisk: "คุณมีความเสี่ยงโรคอะไรบ้าง ?",
  findOutYourRisk: "เพื่อหาวิธีป้องกันและหาแพ็กเกจ\nตรวจสุขภาพที่เหมาะสม",
  doTheTest: "ทำแบบทดสอบ",
  findPackage: "ค้นหาแพ็กเกจ",
  branch: "สาขา",
  popularPackage: "แพ็กเกจยอดนิยม",
  suggestHeader: "คำแนะนำ",
  bookYourPackage: "จองแพ็กเกจสำหรับคุณ",
  analyzedPackage: "เราคัดแพ็กเกจที่เหมาะสมจากข้อมูลการประเมินสุขภาพ",
  riskTitle: "ความเสี่ยง",
  seeMore: "รายละเอียด",
  seeLess: "ดูน้อยลง",
  morePackage: "แนะนำแพ็กเกจตรวจเสริม",
  appointmentDateil: "รายละเอียดการนัดหมาย",
  allAppointment: "นัดหมายทั้งหมด",
  appointmentNumber: "หมายเลขนัดหมาย",
  appointmentDate: "วันที่นัดหมาย",
  appointmentLocation: "สถานที่รับ",
  nextAppointment: "นัดหมายครั้งถัดไป",
  selectAppointmentDate: "เลือกวันนัดหมาย",
  telephoneNumber: "เบอร์โทรศัพท์",
  selectPackage: "เลือกแพ็กเกจ",
  inProgress: "กำลังประเมินผล!",
  inProgressMessage: "โปรดรอซักครู่ เรากำลังนำข้อมูลของคุณ",
  inProgressMessage2: "ไปประเมินหาแพ็คเกจที่เหมาะสมกับคุณ",
  addItem: "เพิ่มลงรายการตรวจ",
  appointmentDetIl: "รายละเอียดนัดหมาย",
  healthCheckup: "ตรวจสุขภาพ",
  package: "แพ็กเกจ",
  manyPackage: "แพ็กเกจ",
  timeOclock: "น.",
  changeBranch: "เปลี่ยนสาขา",
  mostRecommend: "แนะนำที่สุด",
  // showAllPackage
  filter: "ตัวกรอง",
  clearFilter: "ล้าง",
  filterCategory: "แบ่งตามประเภท",
  filterBy: "กรุณาเลือกประเภท",
  recentlyFilter: "เพิ่มล่าสุด",
  recommendFilter: "แนะนำ",
  allPackage: "แพ็กเกจทั้งหมด",
  sortBy: "เรียงตาม",
  seacrhPlaceHolder: "อาการ, ชื่อแพ็กเกจ",
  // booking
  healthPackageBooking: "รายการตรวจสุขภาพ",
  alreadyGetInformation: "เราได้รับข้อมูลของคุณเรียบร้อย",
  // Appointment
  name: "ชื่อ",
  me: "(ฉัน)",
  hospitalVisit: "พบแพทย์ที่โรงพยาบาล",
  contactUs:
    "สอบถามข้อมูลเพิ่มเติมหรือต้องการเลื่อนนัดหมาย สามารถติดต่อเจ้าหน้าที่",
  BEST_SELLER: "แพ็กเกจยอดนิยม",
  STH_RECOMMEND: "แพ็กเกจแนะนำ",
  RECOMMEND: "แพ็กเกจแนะนำ",
};

export default thLocale;
